import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Button, Stack } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import pinImage from '../../images/pin.webp';
import api from '../../api/apiClient';

function PinQuestionPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleYes = async () => {
    await api.post('/pin', {
      answer: true,
    });
    navigate('/thank-you');
  };
  const handleNo = async () => {
    await api.post('/pin', {
      answer: false,
    });
    navigate('/thank-you', { state: { noPin: true } });
  };
  return (
    <div className="p-4 flex flex-col items-center justify-center">
      <Stack direction="column" spacing={2} className="px-5">
        <Typography level="h2" textAlign="center">
          {t('pinQuestionPage.title')}
        </Typography>
        <div className="flex justify-center">
          <img className="w-auto max-w-[300px]" src={pinImage} alt="Card" />
        </div>
        <Stack
          direction="row"
          spacing={2}
          className="flex justify-center w-full"
        >
          <Button
            variant="soft"
            color="success"
            onClick={handleYes}
            className="w-[140px] sm:w-[200px] h-[50px]"
          >
            {t('yes')}
          </Button>
          <Button
            variant="soft"
            color="danger"
            onClick={handleNo}
            className="w-[140px] sm:w-[200px] h-[50px]"
          >
            {t('no')}
          </Button>
        </Stack>
      </Stack>
    </div>
  );
}

export default PinQuestionPage;
